/**
 * Helpers puros para identificar assinantes Apple a partir dos subdocs
 * `subscription/current`. O relatório agregado da Apple nunca revela o
 * comprador; a identidade de quem renovou vive nesses subdocs (atualizados
 * pelo webhook de App Store Server Notifications).
 */

function toDate(value) {
  if (!value) return null;
  if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value;
  if (typeof value?.toDate === 'function') return value.toDate();
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
}

/** É uma assinatura Apple (independente do status)? */
export function isAppleSub(sub) {
  return !!(sub && sub.provider === 'apple');
}

/** Assinatura Apple ativa e não expirada? */
export function isActiveAppleSub(sub, now = new Date()) {
  if (!isAppleSub(sub)) return false;
  if (sub.status !== 'active' && sub.status !== 'trialing') return false;
  const end = toDate(sub.currentPeriodEnd);
  if (end && now.getTime() > end.getTime()) return false;
  return true;
}

/**
 * Monta a linha de assinante Apple para exibição.
 * @param {{id:string, email?:string, name?:string, displayName?:string}} user
 * @param {object} sub subscription/current
 */
export function mapAppleSubscriber(user, sub, now = new Date()) {
  return {
    userId: user.id,
    email: user.email || '',
    name: user.name || user.displayName || '',
    plan: sub.plan || 'free',
    status: sub.status || 'inactive',
    active: isActiveAppleSub(sub, now),
    lastRenewal: toDate(sub.currentPeriodStart),
    nextRenewal: toDate(sub.currentPeriodEnd),
    billingInterval: sub.billingInterval || '',
  };
}

/**
 * Constrói a lista de assinantes Apple a partir de pares (user, sub),
 * ordenada por ativos primeiro e depois por próxima renovação mais recente.
 */
export function buildAppleSubscribers(pairs, now = new Date()) {
  const rows = (Array.isArray(pairs) ? pairs : [])
    .filter(({ sub }) => isAppleSub(sub))
    .map(({ user, sub }) => mapAppleSubscriber(user, sub, now));

  return rows.sort((a, b) => {
    if (a.active !== b.active) return a.active ? -1 : 1;
    const at = a.nextRenewal ? a.nextRenewal.getTime() : 0;
    const bt = b.nextRenewal ? b.nextRenewal.getTime() : 0;
    return bt - at;
  });
}
